import { Layout } from '@components/common'
import { Container, Heading2 } from '@components/ui'
import { Grid, Column } from '@components/common'
import SEO from '@components/common/SEO/SEO'

export default function ShippingPolicy() {
  return (
    <Container>
      {/* Using Grid to Add Top/Bottom Padding w/o Creating a New Component */}
      <Grid xsGutter={30}>
        <Column xs={12}>
          <Heading2>Shipping Policy</Heading2>
          <p>
            We require a signature at delivery on almost all of our shipments.
            Please plan accordingly when you select where to have your order
            shipped. FedEx is our primary carrier. This policy may change once
            FedEx starts documenting deliveries with delivery picture
            confirmation.
          </p>
          <p>
            We can ship to virtually any address in the U.S. Note that there are
            restrictions on some products.
          </p>
          <p>
            When you place an order, we will estimate shipping and delivery
            dates for you based on the availability of your items and the
            shipping options you choose.
          </p>
          <p>
            Please also note that the shipping rates for many items we sell are
            weight-based. The weight of any such item can be found on its detail
            page. To reflect the policies of the shipping companies we use, all
            weights will be rounded up to the next full pound.
          </p>
        </Column>
      </Grid>
      <SEO
        title={'Shipping Policy'}
        description={'Shipping policy for TS Pool Supply.'}
        openGraph={{
          type: 'website',
          title: 'Shipping Policy',
          description: 'Shipping Policy',
          images: [
            {
              url: '/static_images/ts-pool-supply-og-pool.jpg',
              width: 1280,
              height: 720,
              alt: 'TS Pool Supply',
            },
          ],
        }}
      ></SEO>
    </Container>
  )
}

ShippingPolicy.Layout = Layout
